import {
  Title as MantineTitle,
  TitleProps as MantineTitleProps,
  PolymorphicComponentProps,
} from "@mantine/core";
import React, { ReactNode } from "react";

import { useResponsiveValue } from "@contexts";

type ResponsiveValue<T> =
  | T
  | {
      base?: T;
      xs?: T;
      sm?: T;
      md?: T;
      lg?: T;
      xl?: T;
    };

export interface ExtendedTitleProps
  extends Omit<MantineTitleProps, "size" | "children"> {
  size?: ResponsiveValue<MantineTitleProps["size"]>;
  children?: ResponsiveValue<ReactNode>;
}

export type TitleProps<C = "h1"> = PolymorphicComponentProps<
  C,
  ExtendedTitleProps
>;

export const Title = React.forwardRef<HTMLHeadingElement, TitleProps>(
  ({ size, children, ...props }, ref) => {
    const resolvedSize = useResponsiveValue(size);
    const resolvedChildren = useResponsiveValue(children);

    return (
      <MantineTitle ref={ref} size={resolvedSize} {...props}>
        {resolvedChildren}
      </MantineTitle>
    );
  }
) as <C = "h1">(props: TitleProps<C>) => React.ReactElement;
